import React from 'react';

const arrayFields = [
  { key: 'frontend_urls', label: 'Frontend URLs', placeholder: 'https://example.com' },
  { key: 'backend_urls', label: 'Backend URLs', placeholder: 'https://api.example.com' },
  { key: 'api_urls', label: 'API URLs', placeholder: 'https://partner-api.example.com' },
  { key: 'server_ips', label: 'BO IPs', placeholder: '192.168.1.1' },
  { key: 'api_ips', label: 'API IPs', placeholder: '192.168.1.1' },
  { key: 'client_ips', label: 'Client IPs (Whitelist)', placeholder: '192.168.1.1' }
];

const MerchantInfrastructureFields = ({ environment, value, disabled, onInputChange, onArrayChange, onAdd, onRemove }) => (
  <div className="merchant-editor-infrastructure-grid">
    {arrayFields.map(({ key, label, placeholder }) => {
      const field = `${environment}_${key}`;
      const items = value[field];
      return <fieldset className="merchant-editor-array-field" key={field}>
        <legend>{label}</legend>
        {items.map((item, index) => <div className="merchant-editor-array-row" key={index}>
          <input className="input" type="text" aria-label={`${environment} ${label} ${index + 1}`} value={item} placeholder={placeholder}
            disabled={disabled} onChange={event => onArrayChange(event, field, index)} />
          {!disabled && items.length > 1 && <button type="button" className="merchant-editor-remove" aria-label={`Remove ${environment} ${label} ${index + 1}`} onClick={() => onRemove(field, index)}>×</button>}
        </div>)}
        {!disabled && <button type="button" className="merchant-editor-add" aria-label={`Add ${environment} ${label}`} onClick={() => onAdd(field)}>+ Add</button>}
      </fieldset>;
    })}
    {['api_key', 'api_secret'].map(key => <label className="merchant-editor-field" key={key}>
      {key === 'api_key' ? 'API Key' : 'API Secret'}
      <input className="input" type={key === 'api_secret' ? 'password' : 'text'} name={`${environment}_${key}`} value={value[`${environment}_${key}`]}
        onChange={onInputChange} disabled={disabled} autoComplete="new-password" />
    </label>)}
  </div>
);

export default MerchantInfrastructureFields;
